import React, { useEffect, useState } from "react";
import {
  Table,
  Input,
  Button,
  Space,
  Select,
  Tag,
  Divider,
  Image,
  Spin,
  Row,
  Col,
  PageHeader,
  Modal,
  Drawer,
  Radio,
  Typography,
} from "antd";
import Highlighter from "react-highlight-words";
import * as XLSX from "xlsx-js-style";
import {
  FileExcelOutlined,
  FilePdfOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import _ from "lodash";
import moment from "moment";
import { connect } from "react-redux";
import { ImageView } from "../../image/imageView";
import { LanguageContext } from "../../../context/LanguageContext";
import { professionalAction } from "../../../_actions";
import { ViewPrevetiveDetails } from "../../viewPreventive/viewPreventive";
import { CountWantedInfo } from "../../Dashboard/countWantedInfo";
import { wantedHistoryAction } from "../../../_actions/wanted_history.actions";
import { roleAction } from "../../../_actions/roleby.action";
import { adminService } from "../../../_services/admin.service";
import { ViewGunaDetails } from "../../viewGunaDetails/viewGunaDetails";

class TableWantedMemo extends React.Component {
  static contextType = LanguageContext;
  state = {
    imageOpen: false,
    selectedImage: null,
    showGunaDetails: false,
    gunaLoading: false,
    preventiveLoading: false,
    showCountDetails: false,
    districtId: "",
    countDetails: [],
    info: "",
  };
  showGunaViewModel = () => {
    this.setState({
      showGunaDetails: true,
    });
  };

  closeGunaViewModel = () => {
    this.setState({
      showGunaDetails: false,
    });
  };
  showpreventiveViewModel = () => {
    this.setState({
      showpreventive: true,
    });
  };
  closepreventiveViewModel = () => {
    this.setState({
      showpreventive: false,
    });
  };
  showCountDetailsModel = (districtId) => {
    this.setState(
      {
        showCountDetails: true,
        districtId: districtId,
      },
      () => {
        this.wantedInfo();
      },
    );
  };

  wantedInfo = async () => {
    // if (this.props.user.role === "4") {
    //   const temp = {
    //     condition:
    //       this.props.condition != "हिस्ट्रीशिटर" && this.props.condition,
    //     selectDistrict: [this.state.districtId],
    //     cityId: this.props.cityId,
    //     historySheeter: this.props.condition === "हिस्ट्रीशिटर" && 1,
    //   };
    //   try {
    //     const response = await wantedHistoryAction.getWantedHistoryListCityWise(
    //       temp
    //     );
    //     const data = await response.json();
    //     console.log("data", data.data);
    //     this.setState({
    //       countDetails: data.data,
    //     });
    //   } catch (error) {
    //     console.error("Error fetching data:", error);
    //   }
    // } else {
    if (
      this.props.stationType === "accused" &&
      (this.props.condition === "पाहिजे" || this.props.condition === "फरार")
    ) {
      const temp = {
        condition: this.props.condition,
        cityId: this.props.cityId,
        selectDistrict: [this.state.districtId],
      };
      try {
        const response =
          await wantedHistoryAction.getWantedHistoryByAccusedCity(temp);
        const data = await response.json();
        this.setState({
          countDetails: data.data || [],
        });
      } catch (error) {
        console.error("Error fetching accused station count details:", error);
        this.setState({
          countDetails: [],
        });
      }
      return;
    }
    if (this.props.condition != "तडीपार") {
      const temp = {
        condition:
          this.props.condition != "हिस्ट्रीशिटर" && this.props.condition,
        district: [this.state.districtId],
        historySheeter: this.props.condition === "हिस्ट्रीशिटर" && 1,
      };
      try {
        const response = await roleAction.getConditionWantedByRole(temp);
        const data = await response.json();
        console.log("data", data.data);
        this.setState({
          countDetails: data.data,
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    } else {
      const temp = {
        districtId: [this.state.districtId],
      };
      adminService
        .getTadipaarListByDistrict(temp)
        .then((res) => {
          this.setState({
            countDetails: res.results,
          });
        })
        .catch((err) => {
          console.error("Error fetching data:", err);
          this.setState({
            countDetails: [],
          });
        });
    }
  };
  closeCountDetailsModel = () => {
    this.setState({
      showCountDetails: false,
      districtId: "",
      countDetails: [],
    });
  };

  onpreventiveForm = (data) => {
    this.showpreventiveViewModel();
    this.setState({ preventiveLoading: true });
    if (data) {
      this.props.dispatch({
        type: "GET_CRIMINALS_BY_ID_SUCCESS",
        criminalViewList: {},
      });
      this.props.dispatch(professionalAction.getCriminalsViewsById(data));
    }
  };
  onGunaForm = (data) => {
    if (data) {
      this.setState({ gunaLoading: true });
      this.showGunaViewModel();
      this.props.dispatch(professionalAction.getCriminalsViewsById(data));
    }
  };
  componentDidUpdate(prevProps) {
    // Check if the data has just arrived
    const prevList = prevProps.professionals?.criminalViewList?.gunhaInfor;
    const currList = this.props.professionals?.criminalViewList?.gunhaInfor;
    if (this.state.gunaLoading && prevList !== currList) {
      this.setState({ gunaLoading: false });
    }
    const prevPrevetive = prevProps.professionals?.criminalViewList;
    const currtPrevetive = this.props.professionals?.criminalViewList;
    if (this.state.preventiveLoading && prevPrevetive !== currtPrevetive) {
      this.setState({ preventiveLoading: false });
    }
  }
  componentDidMount() {
    this.getPreventiveInfo();
    this.props.dispatch(professionalAction.getCity());
  }
  openImageModal = (img, name, id) => {
    this.setState({ imageOpen: true, selectedImage: img, name: name, id: id });
  };

  closeImageModal = () => {
    this.setState({ imageOpen: false, selectedImage: null, name: null });
  };
  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => this.handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select(), 100);
      }
    },
    render: (text) =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  handleViewForm = (data) => {
    console.log("data", data);
    this.props.onViewAccusedForm(data);
  };
  getSerialNumber = (index, currentPage, pageSize) => {
    console.log("index, currentPage, pageSize", index, currentPage, pageSize);
    return (currentPage - 1) * pageSize + index;
  };

  getPreventiveInfo = () => {
    professionalAction.getPreventiveAction().then((res) => {
      res &&
        res.text().then((preventiveList) => {
          const data = [];
          preventiveList &&
            JSON.parse(preventiveList).data.forEach((item) => {
              data.push(item);
            });
          this.setState({
            preventiveAction: data,
            preventiveActionData: JSON.parse(preventiveList),
          });
        });
    });
  };
  getCityName = (id) => {
    console.log("this.props city", this.props);
    const { pc_cities } = this.props && this.props.professionals;
    if (pc_cities && pc_cities.length) {
      return (
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0] &&
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0].City
      );
    }
  };
  download_csv = (info) => {
    const { t } = this.context;
    const report_name = this.props.condition;
    const file_name = `${report_name}_${moment().format("DDMMMYYYY")}`;
    const ReportTitle = `${this.props.condition}`;

    const arrData = this.state.countDetails.map((data, index) => ({
      [t("sr.no")]: index + 1,

      ...(this.props.condition === "पाहिजे" || this.props.condition === "फरार"
        ? { [t("police_station_required")]: data?.policeSideNeed || "-" }
        : {}),

      ...(this.props.condition === "तडीपार"
        ? {
            [t("police_station_action_by")]:
              data?.action_taken_police_station || "-",
            [t("name")]: data?.name || "-",
            [t("accused_police_station")]: data?.districtName || "-",
            [t("total_crimes")]: data?.totalCrimeCount || data?.gunhaCount || 0,
            [t("period_from")]: data?.date_from
              ? moment(data.date_from).format("DD/MM/YYYY")
              : "-",
            [t("period_to")]: data?.date_to
              ? moment(data.date_to).format("DD/MM/YYYY")
              : "-",
            [t("preventive_action_name")]: data?.preventiveActionName || "-",
          }
        : {
            [t("name")]: data?.name || "-",
            [t("accused_police_station")]: data?.districtName || "-",
            [t("total_crimes")]: data?.totalCrimeCount || data?.gunhaCount || 0,
            [t("photo")]: data?.photos ? t("yes") : t("no"),
          }),
    }));

    if (!arrData.length) return;

    // ================= STYLES =================
    const titleStyle = {
      font: { bold: true, sz: 18, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "1F4E78" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    const subTitleStyle = {
      font: { bold: true, sz: 14, color: { rgb: "1F4E78" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    const headerStyle = {
      font: { bold: true, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "305496" } },
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
    };

    const cellStyle = {
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
    };

    // ================= WORKBOOK =================
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet([]);
    const merges = [];
    const headers = Object.keys(arrData[0]);
    const totalCols = headers.length;

    const cityName = this.getCityName(this.props?.user?.cityId || "");
    const stateName = this.state.info?.districtName;

    const headerData = `${stateName} (${cityName})`;
    console.log("headerData", headerData);

    // ================= TITLES =================
    XLSX.utils.sheet_add_aoa(ws, [[headerData]], { origin: "A1" });
    ws["A1"].s = titleStyle;
    merges.push({ s: { r: 0, c: 0 }, e: { r: 0, c: totalCols - 1 } });

    XLSX.utils.sheet_add_aoa(ws, [[ReportTitle]], { origin: "A2" });
    ws["A2"].s = subTitleStyle;
    merges.push({ s: { r: 1, c: 0 }, e: { r: 1, c: totalCols - 1 } });

    // ================= TABLE HEADERS =================
    XLSX.utils.sheet_add_aoa(ws, [headers], { origin: "A3" });

    headers.forEach((_, c) => {
      const cell = XLSX.utils.encode_cell({ r: 2, c });
      if (ws[cell]) ws[cell].s = headerStyle;
    });

    // ================= TABLE DATA =================
    const ws_data = arrData.map((row) => Object.values(row));
    XLSX.utils.sheet_add_aoa(ws, ws_data, { origin: "A4" });

    ws_data.forEach((row, r) => {
      row.forEach((_, c) => {
        const cell = XLSX.utils.encode_cell({ r: r + 3, c });
        if (ws[cell]) ws[cell].s = cellStyle;
      });
    });

    // ================= FOOTER =================
    const footerRowIndex = ws_data.length + 6;
    const footerContent = `Generated At ${moment().format(
      "DD MMM YYYY",
    )} From Criminal Monitoring Intelligent System`;

    XLSX.utils.sheet_add_aoa(ws, [[footerContent]], {
      origin: `A${footerRowIndex}`,
    });

    ws[`A${footerRowIndex}`].s = {
      font: { italic: true, sz: 12, color: { rgb: "555555" } },
      alignment: { horizontal: "center" },
    };

    merges.push({
      s: { r: footerRowIndex - 1, c: 0 },
      e: { r: footerRowIndex - 1, c: totalCols - 1 },
    });

    // ================= COLUMN WIDTH =================
    ws["!cols"] = headers.map((key) => ({
      wch:
        Math.max(
          key.length,
          ...arrData.map((row) => String(row[key] || "").length),
        ) + 8, // extra spacing for better look
    }));

    // ================= ROW HEIGHT =================
    ws["!rows"] = [{ hpt: 40 }, { hpt: 30 }, { hpt: 28 }]; // title/subtitle/date
    for (let i = 3; i < ws_data.length + 4; i++) {
      ws["!rows"][i] = { hpt: 35 };
    }
    ws["!rows"][footerRowIndex - 1] = { hpt: 28 };

    ws["!freeze"] = { ySplit: 4 };
    ws["!merges"] = merges;

    // ================= EXPORT =================
    XLSX.utils.book_append_sheet(wb, ws, "Report");
    XLSX.writeFile(wb, `${file_name}.xlsx`);
  };

  render() {
    const { language, t } = this.context;
    let tempColumns = [];
    const { professionals, user } = this.props;
    const { info, countDetails } = this.state;
    let columnsOb = [
      {
        title: t("sr.no"),
        key: t("sr.no"),
        render: (text, record) => (
          <Space size="middle" style={{ maxWidth: 300 }}>
            {record.srNo}
          </Space>
        ),
      },
      {
        title: t("name_of_the_accused"),
        key: "name",
        dataIndex: "name",
        render: (text, record) => (
          <Space size="middle" style={{ maxWidth: 300 }}>
            {record.name}
          </Space>
        ),
      },
      // {
      //   title: t("age"),
      //   key: "age",
      //   render: (text, record) => (
      //     <Space size="middle" style={{ maxWidth: 300 }}>
      //       {record.age}
      //     </Space>
      //   ),
      // },
      {
        title: t("accused_police_station"),
        key: "districtName",
        render: (text, record) => (
          <Space size="middle" style={{ maxWidth: 300 }}>
            {record.districtName}
          </Space>
        ),
      },
      {
        title: t("total_crimes"),
        key: "gunhaCount",
        sorter: {
          compare: (a, b) =>
            (a.totalCrimeCount ?? a.gunhaCount) -
            (b.totalCrimeCount ?? b.gunhaCount),
        },
        render: (text, record) => (
          // <Space size="middle" style={{ maxWidth: 300 }}>
          //   {record.totalCrimeCount
          //     ? record.totalCrimeCount
          //     : record.gunhaCount}
          // </Space>
          <div className="action-links-responsive">
            <Button
              type="text"
              size="small"
              className="action-link update-link"
              onClick={() => {
                this.onGunaForm(record.id);
              }}
            >
              {record.totalCrimeCount
                ? record.totalCrimeCount
                : record.gunhaCount}
            </Button>
          </div>
        ),
      },

      {
        title: t("photo"),
        key: "Photo",
        render: (text, record) => (
          <Space size="middle" style={{ maxWidth: 300 }}>
            {record.photo ? (
              <>
                <img
                  style={{ width: 50, height: 50 }}
                  src={
                    "https://pcimageupload.s3.ap-south-1.amazonaws.com/" +
                    record.photo
                  }
                  onClick={() =>
                    this.openImageModal(record.photo, record.name, record.id)
                  }
                ></img>
              </>
            ) : (
              "नाही"
            )}
          </Space>
        ),
      },
      {
        title: t("action"),
        key: "action",
        render: (text, record) => (
          <div className="action-links-responsive">
            <Button
              type="text"
              size="small"
              className="action-link update-link"
              onClick={() => {
                this.handleViewForm(record.id);
              }}
            >
              {t("view1")}
            </Button>
          </div>
        ),
      },
    ];
    if (this.props.condition === "तडीपार") {
      columnsOb.splice(1, 0, {
        title: t("police_station_action_by"),
        key: "action_taken_police_station",
        onHeaderCell: () => ({
          style: {
            backgroundColor: "#fff3e0",
            color: "#000",
            fontWeight: "bold",
          },
        }),
        render: (text, record) => (
          <Space size="middle" style={{ maxWidth: 300 }}>
            {record?.action_taken_police_station}
          </Space>
        ),
      });
    }
    if (this.props.condition != "तडीपार") {
      if (
        this.props.condition === "पाहिजे" ||
        this.props.condition === "फरार"
      ) {
        columnsOb.splice(1, 0, {
          title: t("police_station_required"),
          key: "policeSideNeed",
          onHeaderCell: () => ({
            style: {
              backgroundColor: "#ffcc80",
              color: "#000",
              fontWeight: "bold",
            },
          }),
          onCell: () => ({
            style: {
              backgroundColor: "#ffcc80",
              color: "#000",
            },
          }),
          render: (text, record) => (
            <Space size="middle" style={{ maxWidth: 300 }}>
              {record.policeSideNeed}
            </Space>
          ),
        });
      }
      if (this.props.condition === "हिस्ट्रीशिटर") {
        columnsOb.splice(1, 0, {
          title: t("police_station_required1"),
          key: "policeSideNeed",
          onHeaderCell: () => ({
            style: {
              backgroundColor: "#ffcc80",
              color: "#000",
              fontWeight: "bold",
            },
          }),
          onCell: () => ({
            style: {
              backgroundColor: "#ffcc80",
              color: "#000",
            },
          }),
          render: (text, record) => (
            <Space size="middle" style={{ maxWidth: 300 }}>
              {record.policeSideNeed}
            </Space>
          ),
        });
      }
    }
    if (this.props.condition != "तडीपार") {
      if (
        this.props.condition === "पाहिजे" ||
        this.props.condition === "फरार"
      ) {
        columnsOb.splice(4, 0, {
          title: t("current_status"),
          key: "current_condition",
          render: (text, record) => (
            <Space size="middle" style={{ maxWidth: 300 }}>
              <>
                {this.props.role === "4" ||
                this.props.role === "9" ||
                this.props.role === "10"
                  ? record?.current_condition == "पाहिजे"
                    ? t("required")
                    : record?.current_condition == "फरार"
                      ? t("absconding")
                      : ""
                  : record?.currentcondition == "पाहिजे"
                    ? t("required")
                    : record?.currentcondition == "फरार"
                      ? t("absconding")
                      : ""}
              </>
            </Space>
          ),
        });
        columnsOb.splice(5, 0, {
          title: t("when_to_patrol"),
          key: "date_from",
          render: (text, record) => (
            <Space size="middle" style={{ maxWidth: 300 }}>
              {this.props.role === "4" ||
              this.props.role === "9" ||
              this.props.role === "10"
                ? record?.date_from &&
                  moment(record?.date_from).format("DD/MM/YYYY")
                : record?.current_condition_date &&
                  moment(record?.current_condition_date).format("DD/MM/YYYY")}
            </Space>
          ),
        });
      }
      if (
        this.props.condition === "हिस्ट्रीशिटर" &&
        (this.props.role === "4" ||
          this.props.role === "9" ||
          this.props.role === "10")
      ) {
        columnsOb.splice(4, 0, {
          title: t("history_sheeter_entry_date"),
          key: "date_from",
          render: (text, record) => (
            <Space size="middle" style={{ maxWidth: 300 }}>
              {record?.history_date &&
                moment(record?.history_date).format("DD/MM/YYYY")}
            </Space>
          ),
        });
      }
    }

    if (this.props.condition === "तडीपार") {
      columnsOb.splice(
        4,
        0,
        {
          title: t("preventive_action_status"),
          key: "preventiveActionStatus",
          filters: [
            {
              text: t("ongoing"),
              value: "Ongoing",
            },
            {
              text: t("completed"),
              value: "Completed",
            },
          ],
          onFilter: (value, record) => {
            const today = moment().startOf("day");
            const dateFrom = record.date_from ? moment(record.date_from) : null;
            const dateTo = record.date_to ? moment(record.date_to) : null;

            if (!dateFrom || !dateTo) {
              return false;
            }

            if (value === "Ongoing") {
              return today.isBetween(dateFrom, dateTo, "day", "[]");
            }

            if (value === "Completed") {
              return dateTo.isBefore(today, "day");
            }

            return false;
          },
          render: (text, record) => {
            const today = moment().startOf("day");
            const dateFrom = record.date_from ? moment(record.date_from) : null;
            const dateTo = record.date_to ? moment(record.date_to) : null;

            let status = "";
            let color = "";

            if (dateFrom && dateTo) {
              if (today.isBetween(dateFrom, dateTo, "day", "[]")) {
                status = t("ongoing");
                color = "blue";
              } else if (dateTo.isBefore(today, "day")) {
                status = t("completed");
                color = "green";
              }
            }

            return (
              <Space
                size="middle"
                style={{
                  maxWidth: 300,
                  width: "100%",
                  justifyContent: "center",
                }}
                onClick={() => this.onpreventiveForm(record.id)}
              >
                {status && <Tag color={color}>{status}</Tag>}
              </Space>
            );
          },
        },
        {
          title: t("preventive_action_name"),
          key: "preventiveActionName",
          render: (text, record) => (
            <Space size="middle" style={{ maxWidth: 300 }}>
              {record.preventiveActionName}
            </Space>
          ),
        },
      );
    }

    const stationRadioActive =
      ["2", "4", "9", "10", "12"].includes(String(this.props.role)) &&
      (this.props.stationType === "accused" ||
        this.props.stationType === "crime") &&
      (this.props.condition === "पाहिजे" || this.props.condition === "फरार");

    if (stationRadioActive && columnsOb.length > 3) {
      if (this.props.stationType === "crime") {
        const secondColumn = columnsOb[1];
        const fourthColumn = columnsOb[3];
        columnsOb[1] = fourthColumn;
        columnsOb[3] = secondColumn;
      }

      columnsOb[1].onHeaderCell = () => ({
        style: {
          backgroundColor: "#ffcc80",
          color: "#000",
          fontWeight: "bold",
        },
      });
      columnsOb[1].onCell = () => ({
        style: {
          backgroundColor: "#ffcc80",
          color: "#000",
        },
      });
      columnsOb[3].onHeaderCell = () => ({
        style: {
          backgroundColor: "#91caff",
          color: "#000",
          fontWeight: "bold",
        },
      });
      columnsOb[3].onCell = () => ({
        style: {
          backgroundColor: "#91caff",
          color: "#000",
        },
      });
    }

    let tebleData =
      this.props.data &&
      this.props.data.map((item, index) => {
        return {
          ...item,
          srNo: index + 1,
        };
      });

    // columns.push(
    //   ...columnsOb
    // );

    const count_columns = [
      {
        title: t("sr.no"),
        dataIndex: "srNo",
        key: "srNo",
      },
      {
        title:
          this.props.condition === "हिस्ट्रीशिटर"
            ? t("police_station_required1")
            : this.props.condition === "तडीपार"
              ? t("police_station_action_by")
              : this.props.condition === "फरार"
                ? "पोलिस ठाणे (फरार)"
                : t("police_station_required"),
        dataIndex: "districtName",
        key: "districtName",
      },
      {
        title: t("count"),
        dataIndex: "crimeCount",
        key: "crimeCount",
        sorter: (a, b) => a.numericCrimeCount - b.numericCrimeCount,
        render: (text, record) => (
          <>
            <div>
              <Button
                type="primary"
                shape="circle"
                size="small"
                style={{
                  width: 36,
                  height: 36,
                  fontWeight: 600,
                  boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                }}
                disabled={record.crimeCount === 0}
                onClick={() => {
                  this.showCountDetailsModel(record.districtId);
                  this.setState({ info: record });
                }}
              >
                {record.crimeCount}
              </Button>
            </div>
          </>
        ),
      },
    ];

    return (
      <>
        <Spin spinning={this.props.loading} delay={500}>
          <div
            style={{
              display: "flex",
              gap: "20px",
              marginTop: "20px",
              marginBottom: "20px",
            }}
          >
            <div
              style={{
                background: "#6f42c1",
                color: "#fff",
                padding: "10px 20px",
                borderRadius: "8px",
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <span style={{ fontSize: "16px", fontWeight: "bold" }}>
                {t("total_accused_count")}: {this.props.total_count}
              </span>
            </div>
            {this.props.showList === "list" && (
              <>
                <div
                  style={{
                    background: "#28a745",
                    color: "#fff",
                    padding: "10px 20px",
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  <span style={{ fontSize: "16px", fontWeight: "bold" }}>
                    {t("total_photo_count")}: {this.props.photoCount}
                  </span>
                </div>
                {this.props.data.length > 0 && (
                  <div
                    style={{
                      color: "#fff",
                      padding: "10px 20px",
                      borderRadius: "8px",
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <Radio.Group
                      onChange={(e) => {
                        this.props.handleAdvancedFilterPhotoChange(e);
                      }}
                      value={this.props.advancedFilterPhoto}
                    >
                      <Radio value="all">सर्व</Radio>
                      <Radio value="yes">होय</Radio>
                      <Radio value="no">नाही</Radio>
                    </Radio.Group>
                  </div>
                )}
              </>
            )}
          </div>

          <div style={{ marginBottom: 16 }}>
            <span style={{ marginLeft: 8 }}></span>
          </div>

          <Table
            loading={this.props.loading}
            key={tebleData}
            columns={this.props.showList === "list" ? columnsOb : count_columns}
            dataSource={this.props.showList === "list" ? tebleData : tebleData}
            pagination={{
              showSizeChanger: true,
            }}
          />
        </Spin>
        {this.state.imageOpen && (
          <ImageView
            imageOpen={this.state.imageOpen}
            imageUrl={
              "https://pcimageupload.s3.ap-south-1.amazonaws.com/" +
              this.state.selectedImage
            }
            name={this.state.name}
            onClose={this.closeImageModal}
            id={this.state.id}
          />
        )}
        <Modal
          title={t("crime_information")}
          top
          visible={this.state.showGunaDetails}
          onOk={this.closeGunaViewModel}
          onCancel={this.closeGunaViewModel}
          width={95 + "%"}
        >
          <ViewGunaDetails  
            pc_crimetitles={professionals?.pc_crimetitles}
            dataStates={
              Array.isArray(professionals?.criminalViewList?.gunhaInfor) &&
              professionals?.criminalViewList?.gunhaInfor.length > 0
                ? professionals?.criminalViewList?.gunhaInfor
                : []
            }
            address={
              Array.isArray(professionals?.criminalViewList?.basicInfo) &&
              professionals?.criminalViewList?.basicInfo[0]
                ? professionals?.criminalViewList?.basicInfo[0].address
                : ""
            }
            name={
              Array.isArray(professionals?.criminalViewList?.basicInfo) &&
              professionals?.criminalViewList?.basicInfo[0]
                ? professionals?.criminalViewList?.basicInfo[0].name
                : ""
            }
            loading={this.state.gunaLoading}
            user_details={this.props?.user}
            masterId={
              Array.isArray(professionals?.criminalViewList?.basicInfo) &&
              professionals?.criminalViewList?.basicInfo[0]
                ? professionals?.criminalViewList?.basicInfo[0].id
                : ""
            }
            closeGunaViewModel={this.closeGunaViewModel}
          ></ViewGunaDetails>
        </Modal>
        <Modal
          title={t("preventive_action")}
          top
          visible={this.state.showpreventive}
          onOk={this.closepreventiveViewModel}
          onCancel={this.closepreventiveViewModel}
          width={95 + "%"}
        >
          <ViewPrevetiveDetails
            preventiveAction={this.state?.preventiveAction}
            dataStates={
              Array.isArray(
                this.props.professionals?.criminalViewList?.preventiveInfo,
              ) &&
              this.props.professionals?.criminalViewList?.preventiveInfo
                .length > 0
                ? this.props.professionals?.criminalViewList?.preventiveInfo
                : []
            }
            name={
              Array.isArray(
                this.props.professionals?.criminalViewList?.basicInfo,
              ) && this.props.professionals?.criminalViewList?.basicInfo[0]
                ? this.props.professionals?.criminalViewList?.basicInfo[0].name
                : ""
            }
            loading={this.statepreventiveLoading}
          ></ViewPrevetiveDetails>
        </Modal>
        <Drawer
          width={900}
          title={
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 4,
              }}
            >
              {/* Top Title */}
              <span style={{ fontWeight: "bold", fontSize: 16 }}>
                आरोपींची यादी
              </span>

              {/* Center Content */}
              <Typography.Text
                strong
                style={{
                  color: "#1d39c4",
                  fontSize: 16,
                  textAlign: "center",
                  whiteSpace: "normal",
                  lineHeight: "1.4",
                }}
              >
                {t("police_station")} : {info?.districtName}
                <p>{this.props.condition}</p>
              </Typography.Text>
            </div>
          }
          maskClosable={false}
          closable={false}
          onClose={this.closeCountDetailsModel}
          visible={this.state.showCountDetails}
          footer={
            <div
              style={{
                textAlign: "right",
              }}
            >
              <div
                className="steps-action"
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <Button
                  onClick={this.closeCountDetailsModel}
                  style={{ marginRight: 8 }}
                >
                  Cancel
                </Button>
              </div>
            </div>
          }
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: 4,
            }}
          >
            <span></span>
            {/* RIGHT SIDE BUTTON */}

            <Button
              type="primary"
              size="small"
              disabled={countDetails.length === 0}
              onClick={() => {
                this.download_csv("आरोपींची यादी");
              }}
            >
              Download Excel
            </Button>
          </div>
          <div className="steps-content mb-4" style={{ marginTop: "2px" }}>
            <CountWantedInfo
              data={this.state.countDetails}
              handleViewForm={this.props.onViewAccusedForm}
              condition={this.props.condition}
            />
          </div>
        </Drawer>
      </>
    );
  }
}

function mapStateToProps(state) {
  const { users, authentication, professionals } = state;
  const { user } = authentication;
  return {
    user,
    users,
    professionals,
  };
}
const connectedTableWanted = connect(mapStateToProps)(TableWantedMemo);
export { connectedTableWanted as TableWanted };
